export default "__VITE_ASSET__CbwvWKId__"